<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="row">
        <div class="col-md-6">
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :content_align_x="'justify-content-space-between'" />
            <div class="btn-group modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2 mt-4" style="margin-top:-2px;">
                        <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;" v-html="'Export'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                        <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                            <span class="sr-only"/>
                        </button>
                <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                    <a class="dropdown-item" href="#" v-html="'Export to PDF'" @click="getReport('portrait')"/>
                    <a class="dropdown-item" href="#" v-html="'Export to CSV'" @click="getReport('csv')"/>
                    <a class="dropdown-item" href="#" v-html="'Export to XLSX'" @click="getReport('xlsx')"/>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-content mt-5" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

        
    
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import FormDynamic from '@/components/FormDynamic.vue';
import moment from 'moment';
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "AssignmentInfoByShift",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        FormDynamic
    },

    data() {
        return {
            notyf,
            axios,
            user: this.get_user(),
            rest_api: `search_standard_reports`,
            title_page: 'Assignment Info by Shift Report',
            current_url: `/reports`,
            breadcrumb: Resources.breadcrumb,
            form_format: FormResources.form_format_assignment_info_by_shift,
            form_data: FormResources.form_data_assignment_info_by_shift,
            assignment_info_by_shift_table: Resources.assignment_info_by_shift_table,
            search: '',
            first_request: true,
            pdfSource: '',
            standard_report_id: 25,
            array_options: {
                day_id: [],
                shift_id: []
            }
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        async getInitialData() {
            const form_data = {
                module_id: this.standard_report_id,
                first_request: true,
            }

            this.loader(true)

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) {
                this.fill_data(response.data)

            } else {
                this.error_handling(response)
            }

            this.loader()

            return response.data
        },

        async fill_data(data) {
            this.array_options = data
        },

        async getReport(format) {
            const form_data = {
                standard_report_id: this.standard_report_id,
                headers: this.assignment_info_by_shift_table,
                params: this.form_data,
                format: format
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) {
                if(format == 'portrait') 
                {
                    const base64Data = await this.downloadFile(response, true)
                    var blobUrl = URL.createObjectURL(base64Data);
                    this.pdfSource = blobUrl
                }
                else
                {
                    this.downloadFile(response)
                }
            } else {
                this.error_handling(response)
            }

            this.loader()
        },

    },

    async mounted() {
        if (this.hasPermissions(['Report Read', 'Report Write'])) {
            this.getInitialData()
            this.form_data.day_id = moment().day()
        }
    },
}
</script>
